import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseTakeStimulus;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@instructure/ui-heading';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { makeScrollable } from '@instructure/quiz-core';
import StimulusItems from './StimulusItems';
import StimulusInfo from './StimulusInfo';
import { compose } from 'redux';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { withStyleOverrides } from '@instructure/quiz-common';
var BaseTakeStimulus = /*#__PURE__*/function (_Component) {
  function BaseTakeStimulus() {
    var _this2;
    _classCallCheck(this, BaseTakeStimulus);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BaseTakeStimulus, [].concat(args));
    _defineProperty(_this2, "scrollToInfo", function () {
      _this2.stimulusInfoRef.focus();
    });
    _defineProperty(_this2, "scrollToItems", function () {
      _this2.stimulusItemsRef.focus();
    });
    _defineProperty(_this2, "setInfoRef", function (node) {
      _this2.stimulusInfoRef = node;
    });
    _defineProperty(_this2, "setItemsRef", function (node) {
      _this2.stimulusItemsRef = node;
    });
    return _this2;
  }
  _inherits(BaseTakeStimulus, _Component);
  return _createClass(BaseTakeStimulus, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles({});
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles({});
    }
  }, {
    key: "stimulus",
    get: function get() {
      return this.props.sessionItem.stimulusRecord;
    }
  }, {
    key: "stimulusItems",
    get: function get() {
      return this.props.isOqaat ? List([this.props.sessionItem]) : this.props.sessionItem.getNestedEntries();
    }
  }, {
    key: "renderStimulusInstructions",
    value: function renderStimulusInstructions() {
      var instructions = this.stimulus.instructions;
      if (instructions) {
        return jsx("div", {
          css: this.props.styles.instructions,
          tabIndex: "-1",
          ref: this.setInstructionsRef
        }, jsx("div", {
          css: this.props.styles.instructionsHeader
        }, t('Instructions')), jsx("div", null, instructions));
      }
    }
  }, {
    key: "renderStimulusItems",
    value: function renderStimulusItems() {
      if (this.stimulus.passage) {
        return null;
      }
      var shouldSetHorizontalOrientation = this.stimulus.orientation === 'left' || !this.props.stimulusOrientationEnabled;
      return jsx("div", {
        tabIndex: "-1",
        css: (this.props.styles.items, {
          zIndex: 9999
        }),
        ref: this.setItemsRef
      }, jsx(StimulusItems, {
        items: this.stimulusItems,
        quizSessionId: this.props.quizSessionId,
        scrollToInfo: this.scrollToInfo,
        horizontallyAligned: shouldSetHorizontalOrientation
      }));
    }
  }, {
    key: "renderScreenReaderApplicableQuestions",
    value: function renderScreenReaderApplicableQuestions() {
      if (!this.props.isOqaat) {
        var applicablePositions = this.stimulusItems.map(function (i) {
          return i.position;
        }).join(t(', '));
        return jsx(ScreenReaderContent, null, t('The following text applies to the questions at positions {applicablePositions}', {
          applicablePositions: applicablePositions
        }));
      }
    }
  }, {
    key: "renderA11yHeading",
    value: function renderA11yHeading() {
      var itemsCount = this.stimulusItems.size;
      var positions = this.stimulusItems.map(function (i) {
        return i.position;
      }).join(t(', '));
      var headingText = t('Stimulus for {itemsCount, plural, =1{question} other{questions}}' + ' at {itemsCount, plural, =1{position} other{positions}}: {positions}', {
        itemsCount: itemsCount,
        positions: positions
      });
      return jsx(ScreenReaderContent, {
        as: "div"
      }, jsx(Heading, {
        level: "h2"
      }, headingText));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.root,
        tabIndex: "-1"
      }, this.renderA11yHeading(), this.renderScreenReaderApplicableQuestions(), this.renderStimulusInstructions(), jsx("div", {
        css: this.props.styles.stimulusGroup
      }, jsx("div", {
        tabIndex: "-1",
        ref: this.setInfoRef,
        css: this.props.styles.stimulusInfo
      }, jsx(StimulusInfo, {
        stimulus: this.stimulus,
        scrollToItems: this.scrollToItems
      })), this.renderStimulusItems()));
    }
  }]);
}(Component);
_BaseTakeStimulus = BaseTakeStimulus;
_defineProperty(BaseTakeStimulus, "displayName", 'TakeStimulus');
_defineProperty(BaseTakeStimulus, "componentId", "Quizzes".concat(_BaseTakeStimulus.displayName));
_defineProperty(BaseTakeStimulus, "propTypes", {
  isOqaat: PropTypes.bool,
  quizSessionId: PropTypes.string.isRequired,
  sessionItem: ImmutablePropTypes.record.isRequired,
  stimulusOrientationEnabled: PropTypes.bool.isRequired,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
});
_defineProperty(BaseTakeStimulus, "defaultProps", {
  isOqaat: false
});
export var TakeStimulus = compose(makeScrollable, withStyleOverrides(generateStyle, generateComponentTheme))(BaseTakeStimulus);
export default TakeStimulus;